/**
 * `all_keep_mapping` skips the mapping stage, and mapping is what applies a Sportlogiq swap.
 * Hide it when the last run reported swapped, or when eligibility says maps must be rebuilt
 * (a pending starting-side flip after abort still needs mapping even if `swapped` is stale).
 */
export function isKeepMappingResyncAllowed(
	swapped?: boolean | null,
	keepMappingAllowed?: boolean,
): boolean {
	return keepMappingAllowed !== false && swapped !== true;
}
